



















































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import licenseApi from "@/services/licensing";
import calibrationApi from "@/services/calibration"
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import { edit as EditBundle } from "@/dialogs/bundle";
import { Package } from "@/models/package";
import { Bundle } from "@/models/bundle";
import ProductIcon from "@/components/ProductIcon.vue";
import { Account } from "@/models/account";
import FilterAccount from "@/components/filters/Account.vue";

const log = NSLog("view/Manage/Licensing");

@Component({
  components: {
    loader,
    ProductIcon,
    FilterAccount,
  }
})
export default class ManageLicensing extends Vue {
  private loading = false;
  licenses: any[] = [];
  devices: any[] = [];
  @Getter("globalSelectedAccount") private globalSelectedAccount: any;

  showInactive = false;

  @Getter("packages") storePackages!: Package[];
  private pagination: any = {
    // descending: boolean",
    // page: number",
    rowsPerPage: -1,
    sortBy: "created_at"
    // totalItems: number"
  };

  headers = [
    { value: "id", text: "Id", width: '20px' },
    { value: "type", text: "Type" },
    { value: "credits", text: "Credits" },
    { value: "frequency", text: "Frequency" },
    { value: "active", text: "Active" },
    // { value: "track_credits", text: "Track Credits" },
    { value: "subscription_id", text: "Subscription Id" },
    { value: "device_id", text: "Linked Device IMEI" },
    // { value: "account_id", text: "Account Id" },
    // { value: "previous_credit", text: "Previous Credit" },
    // { value: "next_credit", text: "Next Credit" },
    { value: "expires", text: "Expires" }
  ];

  async refreshLicenses() {
    if (!this.globalSelectedAccount) {
      this.licenses = [];
      return;
    }
    this.loading = true;
    console.log("refreshing licenses")

    try {
      this.licenses = await licenseApi.getAccountLicenses(this.globalSelectedAccount.id);
    } catch (err) {
      console.log(err)
    }
    this.loading = false;
  }

  get visibleLicenses() {
    return this.licenses.filter((v: any) => this.showInactive || v.active);
  }

  async refreshDevices() {
    this.loading = true;
    try {
      this.devices = await calibrationApi.getAllDevices();
      console.log('devices:', this.devices)
    } catch (err) {
      console.log(err)
    }
    this.loading = false;
  }

  getDevice(id: number) {
    if (!+id) return 'Unlinked';
    const device = this.devices.find((d: any) => d.id === id);
    return device ? device.imei : `Unknown ${id}`;
  }

  mounted() {
    this.refreshDevices();
  }

  isExpired(date: string) {
    return moment(date).isBefore(moment())
  }

}
